<template>
  <div>
    <h4 class="text-info">{{ order.client.phone }}</h4>
    <div class="install-control">
      <button @click="next" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  methods: {
    next() {
      this.save();
    },
    save() {
      this.$loading(true);

      logger(this.$http, {
        name: "Проверка пользователя #PAYMART",
        description: `Начало запроса`,
        model_type: "order",
        model_id: this.order.id,
        partner_id: this.partner.id,
      });

      this.$http
        .post(
          `${this.partner["endpoint_url"]}v3/uzum/buyer/check-status?companyId=${this.partner["api_public_key"]}`,
          {
            phone: this.order.client.phone,
          },
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data) {
            switch (response.data.data.status) {
              case 4:
                this.message = "Клиент верефицирован, можно продолжить скоринг";
                this.$emit("getHash", response.data.data.available_periods);
                this.$emit("next", 2); // run to create order
                break;

              case 8:
                this.message = "Пользователь заблокирован";
                break;

              //Остальное все в webvuew

              case 0:
                this.message = "Клиент не найден в системе PAYMART";
                setTimeout(() => {
                  this.$emit("getHash", response.data.data.webview);
                  this.$emit("next", 1);
                }, 10);
                break;

              case 1:
                this.message = "Нужно добавить карту";
                setTimeout(() => {
                  this.$emit("getHash", response.data.data.webview);
                  this.$emit("next", 1);
                }, 10);
                break;

              case 5:
                this.message = "верификация в myid";
                setTimeout(() => {
                  this.$emit("getHash", response.data.data.webview);
                  this.$emit("next", 1);
                }, 10);
                break;

              case 12:
                this.message = "Нужно добавить доверителя";
                setTimeout(() => {
                  this.$emit("getHash", response.data.data.webview);
                  this.$emit("next", 1);
                }, 10);
                break;

              case 2:
                this.message = "Ожидание модерации...";
                setTimeout(() => {
                  this.$emit("getHash", response.data.data.webview);
                  this.$emit("next", 1);
                }, 10);
                break;

              default:
                this.message = "Неизвестный статус от партнера";

                break;
            }

            if (response.data.buyer_id) {
              this.$emit("getBuyer", response.data.buyer_id);
              this.$emit("getLimitUser", response.data.available_balance);
            }

            if (this.message) {
              this.$notify({
                title: "PAYMART",
                message: this.message,
                icon: "ti-save",
                horizontalAlign: "right",
                verticalAlign: "top",
              });

              logger(this.$http, {
                name: "Проверка пользователя #PAYMART",
                description: this.message,
                model_type: "order",
                model_id: this.order.id,
              });
            }
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Проверка пользователя #PAYMART",
            description: `Ошибка системы #PAYMART`,
            model_type: "order",
            model_id: this.order.id,
          });

          alert("Ошибка партнера");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
    };
  },
};
</script>
<style lang="scss">
</style>
